import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MerchantFinancialSetup, MerchantFinancialSetupAPI } from '../..';
import { mbeConfigService } from './mbe-config.service';
import { BasicResponse } from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root',
})
export class MerchantFinancialSetupService {
  private URL;
  private AmassENSURL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.AmassENSURL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find(
        (restUrl: { api: string }) => restUrl.api === 'SDSETUP'
      ).url;
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find(
        (restUrl: { api: string }) => restUrl.api === 'PADM'
      ).url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  // tslint:disable-next-line:max-line-length
  getAllMFS(
    pageIndex: number,
    pageSize: number, 
    sortActive: string,
    sort: string,
    gidFrom: number,
    gidTo: number,
    creationDate: string,
    servicePointName: string
  ): Observable<MerchantFinancialSetupAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<MerchantFinancialSetupAPI>(
      `${this.URL}/mfs/allmfs/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}/${gidFrom ? gidFrom : 0}/${gidTo ? gidTo : 0}/${
        creationDate ? creationDate : '0'
      }/${servicePointName ? servicePointName : '0'}`,
      { headers }
    );
  }

  getMFSSS(id: number): Observable<MerchantFinancialSetup> {
    console.log('id:', id);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<MerchantFinancialSetup>(
      `${this.URL}/mfs/getmfs/${id}`,
      { headers }
    );
  }

  getMFS(id: number): Observable<MerchantFinancialSetup> {
    console.log('id:', id);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<MerchantFinancialSetup>(
      `${this.URL}/mfs/getmfs/${id}`,
      { headers }
    );
  }

  updateMFS(mfs: MerchantFinancialSetup): Observable<BasicResponse> {
    const headers = this.headers;
    const payload = this.normalizeMFSPayload(mfs);
    console.log('Update MFS: ', JSON.stringify(payload));
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/mfs/updatemfs`,
      payload,
      { headers }
    );
  }

  createMFS(fin: MerchantFinancialSetup): Observable<BasicResponse> {
    const headers = this.headers;
    const payload = this.normalizeMFSPayload(fin);
    console.log('Create MFS: ' + JSON.stringify(payload));
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/mfs/createmfs`,
      payload,
      { headers }
    );
  }

  /** Ensure servicePointName is always a string in MFS payloads (API expects string). */
  private normalizeMFSPayload(mfs: MerchantFinancialSetup): MerchantFinancialSetup {
    return {
      ...mfs,
      servicePointName: mfs.servicePointName != null && mfs.servicePointName !== '' ? String(mfs.servicePointName) : ''
    };
  }
}
